import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import uuid from 'uuid';

import DayPicker, { DateUtils } from 'react-day-picker';

import './DateSelector.css';

import MomentLocaleUtils from 'react-day-picker/moment';

export default class DateSelector extends Component {
  constructor(props) {
    super(props);

    this.input = null;
    this.daypicker = null;
    this.clickedInside = false;
    this.clickTimeout = null;
    this.isValidDate = false;
    moment.locale(this.props.locale ? this.props.locale : 'en-gb');
    const defaultValueIsValid = this.props.inputValueAttr && this.props.inputValueAttr !== "" && this.props.inputValueAttr !== null;
    this.state = {
      showOverlay: false,
      value: defaultValueIsValid ? moment(this.props.inputValueAttr, 'L', true).format("DD MMM YYYY") : "",
      selectedDay: defaultValueIsValid ? moment(this.props.inputValueAttr, 'L', true).toDate() : moment().toDate(),
      inputFocused: false,
      errorMessage: false
    };
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.toggleCalendar = this.toggleCalendar.bind(this);
    this.handleOverlayClose = this.handleOverlayClose.bind(this);
    this.handleContainerMouseDown = this.handleContainerMouseDown.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.onPeriodSelected = this.onPeriodSelected.bind(this);
    this.pageClick = this.pageClick.bind(this);
    this.handleYearMonthChange = this.handleYearMonthChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.pageClick, false);
    this.setState({ value: this.props.value });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.properties !== undefined && (this.props.properties.editType === "add-manual-case-documentation-details" || "date-selector-auto-update")) {
      if (this.props.value !== nextProps.value) {
        this.setState({ value: nextProps.value });
        nextProps.value !== undefined ? this.props.setFieldValidtionState(this.props.name, "valid") : '';
        this.props.setdatepicker(nextProps.value, this.props.name);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.pageClick);
    clearTimeout(this.clickTimeout);
  }
  pageClick(e) {
    if (this.state.showOverlay && this.component && !ReactDOM.findDOMNode(this.component).contains(e.target)) {
      this.toggleCalendar();
      e.stopPropagation();
      e.preventDefault();
    }
  };

  handleYearMonthChange(month) {
    this.setState({ month });
  };

  // componentWillReceiveProps(nextProps) {
  //   const defaultValueIsValid = nextProps.inputValueAttr && nextProps.inputValueAttr !== "" && nextProps.inputValueAttr !== null;
  //   this.setState({
  //     value: defaultValueIsValid ? moment(nextProps.inputValueAttr, 'L', true).format("DD MMM YYYY") : "",
  //     selectedDay: defaultValueIsValid ? moment(nextProps.inputValueAttr, 'L', true).toDate() : moment().toDate()
  //   })
  // }

  handleContainerMouseDown() {
    this.clickedInside = true;
    this.clickTimeout = setTimeout(() => {
      this.clickedInside = false;
    }, 0);
  }

  handleInputFocus(e) {
    e.preventDefault();
    this.setState({ "inputFocused": true });
    if (this.input.value === "") {
      this.setState({
        showOverlay: false,
        value: "",
        selectedDay: "",
        errorMessage: false
      });
      return;
    }
    let dateValue = moment(this.state.value);
    this.setState({
      showOverlay: false,
      value: dateValue.format('DD MMM YYYY'),
      selectedDay: dateValue.toDate()
    });
  }

  defaultValue() {
    const defaultValueIsValid = this.props.inputValueAttr && this.props.inputValueAttr !== "" && this.props.inputValueAttr !== null;
    return defaultValueIsValid ? moment(this.props.inputValueAttr, 'L', true) : null
  }

  handleBlur(e) {
    //   if (this.state.inputFocused) {
    //   if(e){
    //     e.preventDefault();
    //     // return;
    //   }
    // }
    const showOverlay = this.clickedInside;
    if (this.input.value === "") {
      this.setState({
        showOverlay,
        value: "",
        selectedDay: "",
        inputFocused: false
      });
      return;
    }
    const inputDate = this.state.value;
    let strDate = '';
    let dateValue = '';
    if (inputDate.length == 8 && inputDate !== 'invalid') {
      const strYear = inputDate.substring(4, 8);
      const strMonth = inputDate.substring(2, 4);
      const strDay = inputDate.substring(0, 2);
      strDate = strYear + strMonth + strDay;
      const isHandleClick = this.handleDayClick(moment(strDate));
      if (isHandleClick === false) {
        this.setState({
          showOverlay,
          value: '',
          errorMessage: true,
          selectedDay: '',
          inputFocused: false
        });
        return;
      }
      dateValue = moment(strDate);
    }
    else {
      dateValue = moment(this.state.value);
    }

    if (dateValue.isValid() === false || dateValue === null || this.state.value.length < 8) {
      dateValue = this.defaultValue();
      this.setState({
        showOverlay,
        value: '',
        selectedDay: '',
        inputFocused: false,
        errorMessage: true
      });
      return;
    }
    this.setState({
      showOverlay,
      value: dateValue.format('DD MMM YYYY'),
      selectedDay: dateValue.toDate(),
      inputFocused: false,
      errorMessage: false
    }, function () {

    });

    //if (this.props.onDateSelected)
    //  this.props.onDateSelected(moment(this.state.selectedDay).toDate())

    if (e) {

      e.preventDefault();
      e.stopPropagation();
    }
  }

  toggleCalendar(e) {
    if (e) e.preventDefault();
    if (this.input.value === "") {
      this.setState({
        showOverlay: true,
        value: "",
        selectedDay: "",
        errorMessage: false,
      });
      return;
    }

    let dateValue = moment(this.state.value);
    this.setState({
      showOverlay: !this.state.showOverlay,
      value: dateValue.format('DD MMM YYYY'),
      selectedDay: dateValue.toDate(),
      month: dateValue.getMonth
    });
    // this.setState({
    //   showOverlay: !this.state.showOverlay
    //   //inputFocused: !this.state.inputFocused
    // });
  }

  handleKeyPress(event) {
    // if (e.key === 'Enter')
    if (event.type === 'click' || event.charCode === 32 || event.charCode === 13) {
      this.clickedInside = false;
      this.handleBlur(event);
      this.input.blur();
      return;
    } else {
      //this.input.focus();
      //e.preventDefault();
    }
  }
  handleKeyDown(event) {
    if (event.keyCode === 8) {
      this.setState({
        value: '',
        selectedDay: '',
        inputFocused: false
      });
      this.props.handleBackspace();
      return;
    }
  }
  handleOverlayClose(e) {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      showOverlay: false
    });
  }

  handleInputChange(event) {
    const { value } = event.target;
    const prevDad = this.state.selectedDay;
    if (value) {
      let reg = /^(?=.*\d)[\d ]+$/;
      let check = reg.test(value);
      if (!check || value.length > 8) {
        return false;
      }
    }
    const momentDay = moment(value, 'L', true);
    if (momentDay.isValid()) {
      this.setState({
        selectedDay: momentDay.toDate(),
        value
      }, () => {
        this.daypicker.showMonth(this.state.selectedDay);
        if (prevDad !== this.state.selectedDay) {
          if (this.props.onDateSelected) {
            this.props.onDateSelected(this.state.selectedDay);
          }
        }
        this.setState({
          showOverlay: false
        })
        this.input.blur(null);
      });
    } else {
      this.setState({ value, selectedDay: null });
    }

  }


  handleDayClick(day) {
    var todaysDate = new Date();
    if (this.props.name === "dateOfBirth") {
      var pastDate = new Date(1900, 0, 1);
      var tomorrow = new Date();
      tomorrow.setDate(todaysDate.getDate());

    } else if (this.props.name === "issueDateDocId") {
      var pastDate = new Date(1900, 0, 1);
      var tomorrow = new Date();
      tomorrow.setDate(todaysDate.getDate());
    } else if (this.props.name === "signDateOfIssue") {
      var pastDate = new Date(1900, 0, 1);
      var tomorrow = new Date();
      tomorrow.setDate(todaysDate.getDate());
    } else if (this.props.name === "expiryDateDocId") {
      var pastDate = new Date(1900, 0, 1);
    } else if (this.props.name === "signExpirationDate") {
      var pastDate = new Date(1900, 0, 1);
    }
    else if (this.props.name === this.props.currentName) {
      var pastDate = new Date(1900, 0, 1);
      var tomorrow = new Date();
      tomorrow.setDate(todaysDate.getDate());

    } else if (this.props.name === this.props.pastName) {
      var pastDate = new Date(1900, 0, 1);
      // var tomorrow = new Date();
      //tomorrow.setDate();
      // tomorrow.setDate(todaysDate.getDate()+90);
    } else {
      var tomorrow = new Date();
      tomorrow.setDate(todaysDate.getDate() + 90);
      var pastDate = new Date(1600, 0, 1);
    }

    if (day > tomorrow || day < pastDate || day === tomorrow) {
      return false;
    } else {
      let prevValue = this.state.value;
      let dateValue = moment(day, 'L', true).format('DD MMM YYYY');
      this.setState({
        value: dateValue,
        selectedDay: day,
        showOverlay: false
      }, function () {
        this.props.setdatepicker(this.state.value, this.props.name);
        this.props.setFieldValidtionState(this.props.name, "valid");
      });

      this.input.blur(null);
      if (prevValue !== dateValue) {
        if (this.props.onDateSelected)
          this.props.onDateSelected(day);
      }
    }
  }

  onPeriodSelected(e) {
    this.handleOverlayClose(e);
    this.props.onPeriodSelected(e);
  }

  render() {
    var todaysDate = new Date();
    if (this.props.name === "dateOfBirth") {
      var pastDate = new Date(1900, 0, 1);
      var tomorrow = new Date();
      tomorrow.setDate(todaysDate.getDate());
    } else if (this.props.name === "issueDateDocId") {
      var pastDate = new Date(1900, 0, 1);
      var tomorrow = new Date();
      tomorrow.setDate(todaysDate.getDate());
    } else if (this.props.name === "signDateOfIssue") {
      var pastDate = new Date(1900, 0, 1);
      var tomorrow = new Date();
      tomorrow.setDate(todaysDate.getDate());
    } else if (this.props.name === "signExpirationDate") {
      var pastDate = new Date(1900, 0, 1);
    } else if (this.props.name === "expiryDateDocId") {
      var pastDate = new Date(1900, 0, 1);
    } else if (this.props.name === this.props.currentName) {
      var pastDate = new Date(1900, 0, 1);
      var tomorrow = new Date();
      tomorrow.setDate(todaysDate.getDate());
    } else if (this.props.name === this.props.pastName) {
      var pastDate = new Date(1900, 0, 1);
      //var tomorrow = new Date();
      // tomorrow.setDate();
      // tomorrow.setDate(todaysDate.getDate()+90);
    } else {
      var pastDate = new Date(1600, 0, 1);
      var tomorrow = new Date();
      tomorrow.setDate(todaysDate.getDate() + 90);
    }
    return (
      <div className="date-selector date-selector-float"
        role="Date Selector"
        aria-describedby="Date Selection"
        aria-labelledby={this.props.name}
        onMouseDown={this.handleContainerMouseDown}
        onBlur={this.handleBlur}
        ref={(component) => {
          this.component = component;
        }}
      >
        <input
          ref={(el) => { this.input = el; }}
          className={'date-selector__input form__control datepicker__input ' + this.props.inputClassAttr}
          id={this.props.inputIdAttr}
          type={this.props.inputTypeAttr}
          placeholder={'DD/MM/YYYY'}
          value={this.state.value}
          onChange={this.handleInputChange}
          onFocus={this.handleInputFocus}
          onKeyPress={this.handleKeyPress}
          onKeyDown={this.handleKeyDown}
          tabIndex={this.props.tabIndex}
          name={this.props.name}
          readOnly={this.props.readOnly}
        />
        {this.props.showIcon &&
          <div
            className={(this.props.inputClassAttr && this.props.inputClassAttr.includes('xl')) ?
              'date-selector__icon-wrapper date-selector__icon-wrapper--xl ' : 'date-selector__icon-wrapper'}
          >
            <a
              onClick={this.toggleCalendar}
              //onBlur={ this.handleBlur }
              href="#"
              className="date-selector__trigger"
              tabIndex={this.props.tabIndex}
              aria-haspopup="true"
              aria-label="Date Selector"
              aria-expanded={this.state.showOverlay}
              aria-controls={'calendar-' + uuid.v1()}
              id={'calendar-trigger-' + uuid.v1()}
            >
              <i className="icon icon-calendar"></i>
            </a>
          </div>
        }

        {
          this.state.errorMessage ? <div className="input-error-msg-section"><span className="icon icon-circle-delete-solid"></span>{"Please enter valid Date."}</div> : ''
        }
        {this.state.showOverlay &&
          <div
            tabIndex="0"
            className=
            {!this.props.extendedPanel ?
              'date-selector__panel' :
              'date-selector__panel date-selector__panel--' + ((this.props.dateRangeOptions.length) > 6 ? 'double-extended' : 'extended')
            }
            id={'calendar-' + uuid.v1()}
            aria-labelledby={'calendar-trigger-' + uuid.v1()}
            aria-hidden={!this.state.showOverlay}
          >
            <div
              className={this.props.extendedPanel ? 'date-selector__calendar-wrap date-selector__calendar-wrap--extended' : 'date-selector__calendar-wrap'}>
              <DayPicker
                className="YearNavigation"
                ref={(el) => { this.daypicker = el; }}
                month={this.state.month}
                localeUtils={MomentLocaleUtils}
                initialMonth={this.state.selectedDay || undefined}
                onDayClick={this.handleDayClick}
                selectedDays={day => DateUtils.isSameDay(this.state.selectedDay, day)}
                // disabledDays={ day=>  this.props.disableDateFunction(day) }
                captionElement={
                  <YearMonthForm onChange={this.handleYearMonthChange} />
                }
                disabledDays={[
                  {
                    after: new Date(tomorrow)
                  }, {
                    before: pastDate
                  }
                ]}
              />
            </div>

          </div>
        }
      </div>
    );
  }
}

DateSelector.propTypes = {
  inputTypeAttr: PropTypes.string,
  inputClassAttr: PropTypes.string,
  inputIdAttr: PropTypes.string,
  inputPlaceholderAttr: PropTypes.string,
  inputOnBlur: PropTypes.func,
  showIcon: PropTypes.bool,
  extendedPanel: PropTypes.bool,
  onDateSelected: PropTypes.func,
  errorMessage: PropTypes.string,
  locale: PropTypes.string
};

function YearMonthForm({ date, localeUtils, onChange }) {
  const months = localeUtils.getMonths();

  const shortMonths = moment.monthsShort();

  const handleChange = function handleChange(e) {
    const { year, month } = e.target.form;
    onChange(new Date(year.value, month.value));
  };

  const handleMonthChange = function handleMonthChange(i) {
    //let newDate= new Date(date);
    onChange(new Date(date.setMonth(date.getMonth() + i)));
  }
  const handleYearChange = function handleMonthChange(i) {
    //let newDate= new Date(date);
    months.map((month, i) => { });
    onChange(new Date(date.setYear(date.getYear() + i + 1900)));
  }

  return (
    <div className="calendar-controls">
      {/*<div className="calendar-controls__controls calendar-controls__controls--lefthand gdoc-flt-lft">
        <input
        className="calendar-controls__control calendar-controls__control--backwards"
        type="button"
        value="&#xe000;"
        onClick={()=>handleYearChange(-1)}/>*/}
      <span className="calendar-controls__control calendar-controls__control--backwards icon icon-chevron-double-left gdoc-cal-icon-style" aria-label="Previous Year" onClick={() => handleYearChange(-1)} onkeyPress={() => handleYearChange(-1)} role="button"></span>
      <span className="calendar-controls__control calendar-controls__control--year calendar-controls__control--backwards icon icon-chevron-left gdoc-cal-icon-style" aria-label="Previous Month" onClick={() => handleMonthChange(-1)} onkeyPress={() => handleMonthChange(-1)} role="button"></span>
      {/*<input
        className="calendar-controls__control calendar-controls__control--year calendar-controls__control--backwards"
        type="button"
        value="&#xf058;"
        onClick={()=>handleMonthChange(-1)}
        />
      </div>*/}
      <span className="calendar-controls__label gdoc-month-year-align">
        {shortMonths[date.getMonth()]} {date.getYear() + 1900}
      </span>
      {/*<div className="calendar-controls__controls calendar-controls__controls--righthand gdoc-flt-lft">
    <input
    className="calendar-controls__control calendar-controls__control--year calendar-controls__control--forwards"
    type="button"
    value="&#xf057;"
    onClick={()=>handleMonthChange(1)}
    />*/}
      <span className="calendar-controls__control calendar-controls__control--year calendar-controls__control--forwards icon icon-chevron-right gdoc-cal-icon-style" aria-label="Next Month" onClick={() => handleMonthChange(1)} onkeyPress={() => handleMonthChange(1)} role="button"></span>
      <span className="calendar-controls__control calendar-controls__control--forwards icon icon-chevron-double-right gdoc-cal-icon-style" aria-label="Next Year" onClick={() => handleYearChange(1)} onkeyPress={() => handleYearChange(1)} role="button"></span>
      {/*<input
    className="calendar-controls__control calendar-controls__control--forwards"
    type="button"
    value="&#xe002;"
    onClick={()=>handleYearChange(1)}
    />
    </div>*/}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/DateSelector/DateSelector.js